import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-modal-action-btns',
  templateUrl: './modal-action-btns.component.html',
  styleUrls: ['./modal-action-btns.component.scss'],
})
export class ModalActionBtnsComponent implements OnInit, OnChanges {
  @Input('form') form: UntypedFormGroup | UntypedFormArray | null = null;
  @Input('rejectTitle') rejectTitle: string = 'Cancel';
  @Input('confirmTitle') confirmTitle: string = 'Save';
  @Input('disabled') disabled: boolean = false;
  @Input('useCustomDisabled') useCustomDisabled: boolean = false;
  @Input('showCancel') showCancel: boolean = true;
  @Input('showSave') showSave: boolean = true;
  @Input('resetSubmitting') resetSubmitting: boolean | number = false;
  @Input('useFormSubmit') useFormSubmit: boolean = true; // Default to form submission
  @Output('onReject') onReject = new EventEmitter();
  @Output('onConfirm') onConfirm = new EventEmitter();

  isSubmitting: boolean = false;
  
  /**
   * Public method to set the submitting state
   * Can be called from parent component to disable button during submission
   */
  setSubmittingState(value: boolean): void {
    this.isSubmitting = value;
  }

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    // Reset submitting state whenever resetSubmitting input changes.
    // Supports both boolean (true) and numeric token (increment) resets.
    if (changes['resetSubmitting'] && !changes['resetSubmitting'].isFirstChange()) {
      this.isSubmitting = false;
    }
  }

  onButtonClick(): void {
    // Set submitting state immediately to disable button and prevent double-clicks
    // The form's ngSubmit will handle the actual submission
    if (!this.isSubmitting) {
      this.isSubmitting = true;
    }
  }

  handleConfirm(): void {
    if (!this.isSubmitting) {
      this.isSubmitting = true;
      // Emit onConfirm for custom handlers (if any)
      this.onConfirm.emit();
    }
  }

  onConfirmButtonClick(event?: Event): void {
    // If using form submission, don't do anything here
    // Let the native form submission work - the form's (ngSubmit) will handle it
    // The parent component's onSubmit() will call setSubmittingState(true) to disable the button
    if (this.useFormSubmit) {
      return;
    }
    
    // For custom handlers (like copy component), handle the click
    // This will disable the button and emit onConfirm
    this.handleConfirm();
  }

  /**
   * Public method to reset the submitting state
   * Can be called from parent component via ViewChild
   */
  resetSubmittingState(): void {
    this.isSubmitting = false;
  }
}
